import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type CsticUpdate } from "~/features/configurator/Linear/api/sendLinearConfiguratorUpdate";
import { sendShaft } from "~/features/configurator/Shaft/api/sendShaftCommon";
import { ConfiguratorType } from "~/domains/configurator/types/ConfiguratorType";
import { radialThread, SHAFT_MACHINING_MIDDLE } from "~/features/configurator/Shaft/metric/metricCsticConstants";
import { KmatType } from "~/features/configurator/Linear/kmatType";
import { buildConfiguratorMutationCommand } from "~/features/configurator/common/api/configuratorCommands";

export function sendShaftUpdate(
  linearState: LinearConfiguratorState,
  updatedCstics: CsticUpdate[],
): Promise<LinearConfiguration | null> {
  let changes = updatedCstics;
  if (linearState.type === ConfiguratorType.MetricShaft) {
    const middleMachiningValue = linearState.kmats[KmatType.Main][0].cstics[SHAFT_MACHINING_MIDDLE]?.value;
    const alarModeValue = linearState.kmats[KmatType.Main][0].cstics[radialThread.aLaRMode]?.value;

    if (middleMachiningValue === "980" && !alarModeValue) {
      changes = [
        ...updatedCstics,
        {
          key: radialThread.aLaRMode,
          type: KmatType.Main,
          index: 0,
          value: "S",
        },
      ];
    }
  }

  const result = buildConfiguratorMutationCommand(linearState, changes);
  return result.kind === "local-only" ? Promise.resolve(null) : sendShaft(result.command, linearState.type!);
}
